module.exports = __webpack_public_path__ + "img/fshop.3dd53184.png";